import { uiComponents, uiStates } from '@/tools/viewState';

import { actionTypes, mutationTypes, articleTypes, errorTypes } from '@/types';
import { SEARCH_SCOPES } from '@/tools/consts';
import { generateUUID } from '@/tools/helpers';
import { setUrlToDataSource } from '@/tools/setUrlToDataSource';

/**
 * This action open the ui--search with scope Articles. Pass an exhibitionID to
 * show all articles of belonging exhibition
 * @param {*} store
 * @param { id } exhibitionID
 * @params { { sortBy } } options sorty which tag (name, title, description) default title
 */
export default function({ rootState, commit, dispatch }, { exhibitionID, options = {} }) {
	const exhibition = rootState.dataSourceCFG.exhibitionMap[exhibitionID];
	const { sortBy } = Object.assign({ sortBy: 'title' }, options);
	if (!exhibition) {
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unkownExhibition) });
		return;
	}
	let data = exhibition.articles
		.filter(
			article =>
				article[1].type !== articleTypes.articleList &&
				article[1].type !== 'auto' &&
				article[1].isInExhibitList
		)
		.map(idValuePair => {
			const [id, article] = idValuePair;
			const languageContent = article.languageContent.filter(
				lc => lc.languageISO === rootState.persistent.language
			)[0];
			languageContent.cover = languageContent.coverImage
				? setUrlToDataSource(`../media-${languageContent.coverImage}/512`, rootState.dataSourceURL)
				: undefined;

			return {
				id,
				key: generateUUID(),
				name: article.name,
				class: 'data--' + id,
				role: 'link',
				active: `${rootState.visitedArticleIDs.hasOwnProperty(id)}`,
				url: '',
				click: () => {
					commit(mutationTypes.viewStateSetUiState, {
						id: uiComponents.uiSearchArticles,
						uiState: uiStates.hidden,
					});
					dispatch(actionTypes.setExhibition, { exhibitionID, articleID: id });
				},
				...languageContent,
			};
		});
	data.sort((a, b) => {
		/* eslint-disable no-nested-ternary */
		return a[sortBy] > b[sortBy] ? 1 : a[sortBy] < b[sortBy] ? -1 : 0;
	});

	commit(mutationTypes.searchSetData, {
		scope: SEARCH_SCOPES.articles,
		data,
		searchOptions: {
			keys: ['title', 'description'],
			threshold: 0.3,
			caseSensitive: false,
		},
		options,
	});
	commit(mutationTypes.viewStateSetUiState, {
		id: uiComponents.uiSearchArticles,
		uiState: uiStates.maximised,
	});
}
